export const GET_LINKED_USER_DETAILS = 'GET_LINKED_USER_DETAILS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
